export const cloneDeep = s => JSON.parse(JSON.stringify(s))